import { render } from "./PersonalInformationCheckBox.vue?vue&type=template&id=0520f780&scoped=true"
import script from "./PersonalInformationCheckBox.vue?vue&type=script&lang=js"
export * from "./PersonalInformationCheckBox.vue?vue&type=script&lang=js"

import "./PersonalInformationCheckBox.vue?vue&type=style&index=0&id=0520f780&scoped=true&lang=css"

import exportComponent from "/Users/matsunohiroshi/myact/smari/sumari-deliverybox/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0520f780"]])

export default __exports__